module.exports = require("@mui/icons-material/Search");